import React from "react";
import { Col, Row } from "reactstrap";
import RearrangeIcon from "assets/images/banner_rearrange.svg";

import "./RearrangeButton.scss";

interface IRearrangeButton {
  clickHandler: () => void;
}

const RearrangeButton = (props: IRearrangeButton) => {
  const { clickHandler } = props;
  return (
    <div
      className="btn-primary-outline btn btn-secondary rearrange-container"
      onClick={clickHandler}
    >
      <Row>
        <Col lg="2" className="drag-icon">
          <img src={RearrangeIcon} alt="drag" />
        </Col>
        <Col lg="9" className="button-text">
          Re arrange
        </Col>
      </Row>
    </div>
  );
};

RearrangeButton.defaultProps = {
  clickHandler: () => {},
};

export default RearrangeButton;
